import React from 'react';

/**
 * EmptyState: dashed card that explains what to do next.
 * Light theme only.
 */
export interface EmptyStateProps {
  title: string;
  description?: React.ReactNode;
  /** lucide-react icon, 24-28px. */
  icon?: React.ReactNode;
  /** Primary action(s), e.g. a button. */
  action?: React.ReactNode;
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title,
  description,
  icon,
  action,
  className = '',
}) => (
  <div
    className={`flex flex-col items-center gap-2 rounded-xl border border-dashed border-gray-300 bg-white px-6 py-10 text-center ${className}`.trim()}
  >
    {icon ? (
      <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#F5F3FF] text-[#5A21C9]">
        {icon}
      </div>
    ) : null}
    <h3 className="text-base font-bold text-gray-900">{title}</h3>
    {description ? <p className="max-w-md text-sm text-gray-600">{description}</p> : null}
    {action ? <div className="mt-2 flex flex-wrap justify-center gap-2">{action}</div> : null}
  </div>
);

export default EmptyState;
